import bgTwo from '../assets/images/bgTwo.png';
import secondHeader from '../assets/images/secondHeader.png';
import abdalruhman from '../assets/images/sessions/abdalruhman.png';
import abdelaziz from '../assets/images/sessions/abdelaziz.png';
import binSaud from '../assets/images/sessions/binSaud.png';
import sadhan from '../assets/images/sessions/sadhan.png';
import shamry from '../assets/images/sessions/shamry.png';
import aaed from '../assets/images/sessions/aaed.png';
import salman from '../assets/images/sessions/salman.png';
import ali from '../assets/images/sessions/ali.png';
import ahmedAlKhebty from '../assets/images/sessions/ahmedAlKhebty.png';
import fahd from '../assets/images/sessions/fahd.png';
import haitham from '../assets/images/sessions/haitham.png';
import ibrahim from '../assets/images/sessions/ibrahim.png';
import PageHeader from '../components/PageHeader';
import AnimatedSection, { AnimatedGroup, AnimatedItem } from '../components/AnimatedSection';

const SpeakerCard = ({
    image,
    alt,
    name,
    title,
    size = 'large',
    bgClass = 'bg-white',
    className = '',
    nameClassName = '',
    titleClassName = '',
}) => {
    const isLarge = size === 'large';
    const imgSize = isLarge ? 'w-[144px] h-[144px]' : 'w-[110px] h-[110px]';
    const overlap = isLarge ? '-mr-[72px]' : '-mr-[55px]';
    const padding = isLarge ? 'pl-[88px] pr-6 py-5' : 'pl-[65px] pr-4 py-4';
    const minHeight = isLarge ? 'min-h-[120px]' : 'min-h-[90px]';
    const maxWidth = isLarge ? 'max-w-[500px]' : 'max-w-[360px]';
    const shadow = isLarge ? 'shadow-md' : 'shadow-sm';
    const defaultNameClass = isLarge
        ? 'text-[#3E82B9] md:text-base text-sm font-bold mb-2'
        : 'text-[#3E82B9] md:text-base text-sm font-bold mb-1';
    const defaultTitleClass = isLarge
        ? 'text-[#031246] md:text-[14px] text-[12px] font-[400]'
        : 'text-[#031246] md:text-[13px] text-[11px] font-normal';

    return (
        <div dir="ltr" className={`flex items-center w-full ${maxWidth} ${className}`}>
            <img
                src={image}
                alt={alt}
                className={`${imgSize} rounded-full shrink-0 border border-[#3E82B9] z-10 object-cover bg-gray-200 ${shadow} ${overlap} relative`}
            />
            <div className={`border border-[#3E82B9] rounded-[12px] ${padding} ${minHeight} flex flex-col justify-center ${bgClass} flex-1 min-w-0`}>
                <h4 dir="rtl" className={nameClassName || defaultNameClass}>
                    {name}
                </h4>
                <p dir="rtl" className={titleClassName || defaultTitleClass}>
                    {title}
                </p>
            </div>
        </div>
    );
};

const Sessions = () => {
    return (
        <>
            <PageHeader image={bgTwo} title="الجلسات الحوارية" />

            <AnimatedSection as="div" className="w-full bg-white p-6 md:p-12 flex flex-col items-center">
                <div className="w-full max-w-[1100px]">

                    <h2 className="text-[43px] font-[400] text-black mb-12">
                    تفاصيل الجلسة الافتتاحية
                    </h2>

                    <div className="flex flex-col mb-16 w-full">
                    <h3 className="text-[#3E82B9] text-[22px] font-[700] mb-4">
                        ادارة الجلسة:
                    </h3>

                    <SpeakerCard
                        image={abdalruhman}
                        alt="الدكتور عبدالرحمن بن نبيل الصالح"
                        name="الدكتور عبدالرحمن بن نبيل الصالح"
                        title="أمين مجلس إدارة جامعة سعود وعضو هيئة تدريس في كلية الحقوق والعلوم السياسية"
                        className="self-start"
                    />
                    </div>

                    <div
                    className="bg-white rounded-[20px] p-8 md:p-16 w-full mx-auto flex flex-col items-center"
                    style={{
                        boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                    }}
                    >
                    <h3 className="text-[#3E82B9] text-[29px] font-bold mb-4">
                        المحور
                    </h3>
                    <h4 className="text-[#111827] text-[29px] font-semibold mb-16 text-center">
                        الحوكمة: اختلاف النهج بين التشريع والتنفيذ
                    </h4>

                    <div className="lg:flex justify-center gap-x-24 gap-y-12 w-full">
                        <SpeakerCard
                            image={abdelaziz}
                            alt="معالي عبد العزيز بن سعود الدحيم"
                            name="معالي عبد العزيز بن سعود الدحيم"
                            title=" مساعد وزير التجارة"
                        />
                        <SpeakerCard
                            image={binSaud}
                            alt="سعادة المهندس عبد الله بن سعود الحماد"
                            name="سعادة المهندس عبد الله بن سعود الحماد"
                            title="الرئيس التنفيذي للهيئة العامة للعقار"
                            className="mt-16 lg:mt-0"
                        />
                    </div>
                    </div>
                </div>
            </AnimatedSection>

            <AnimatedSection as="div"  className="w-full bg-[#F5F6F8] p-6 md:p-12 flex flex-col items-center">
                <div className="w-full max-w-[1200px]">
                    
                    <h2 className="text-[43px] font-normal mb-12"> تفاصيل الجلسة الاولى </h2>

                    <div className="flex flex-col mb-16 w-full">
                        <h3 className="text-[#3E82B9] text-[29px] font-bold mb-4">
                            ادارة الجلسة:
                        </h3>

                        <SpeakerCard
                            image={sadhan}
                            alt="الدكتور خالد السدحان"
                            name="الدكتور خالد بن سامي السدحان"
                            title="مستشار قانوني وعضو هيئة تدريس في كلية الحقوق والعلوم السياسية في جامعة الملك سعود"
                        />
                    </div>

                    <AnimatedGroup className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">

                        <AnimatedItem
                            className="bg-white rounded-[20px] p-8 flex flex-col h-full"
                            style={{
                            boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                            المحور الاول
                            </h3>
                            <h4 className="text-black md:text-[29px] text-[22px] font-semibold mb-6 text-center leading-relaxed px-4">
                            التناسب بين صناعة التشريعات وتطبيقاتها في الأسواق المالية
                            </h4>
                            
                            <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                                <p>
                                    1- يتناول من منظور قضائي العلاقة بين التشريعات والحوكمة ودعم الأعمال من خلال استعراض أثر الأحكام والمبادئ القضائية في تعزيز الاستقرار التشريعي.
                                </p>
                                <p>
                                    2- إبراز دور القضاء في تحقيق التوازن بين حماية الحقوق، وكفاءة الأسواق، وتمكين بيئة الأعمال، بما يسهم في تطوير المنظومة التشريعية وتعزيز الثقة في الاستثمار.
                                </p>
                            </div>

                            <SpeakerCard
                                image={shamry}
                                alt="الأستاذ سعود الشمري"
                                name="الأستاذ سعود الشمري"
                                title="رئيس الدائرة الأولى في لجنة الفصل في منازعات الأوراق المالية"
                                size="small"
                                className="self-center mt-auto"
                            />
                        </AnimatedItem>

                        <AnimatedItem
                            className="bg-white rounded-[20px] p-8 flex flex-col h-full"
                            style={{
                            boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                            المحور الثاني
                            </h3>
                            <h4 className="text-black md:text-[29px] text-[22px] font-semibold mb-6 text-center leading-relaxed px-4">
                            التحول المؤسسي وحوكمة الشركات العائلية والخاصة
                            </h4>
                            
                            <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                            <p>
                                1- التحديات العملية في فصل الملكية عن الإدارة في الشركات العائلية، وآليات إعداد وتفعيل الميثاق العائلي للحد من النزاعات.
                            </p>
                            <p>
                                2- أهمية إدخال أعضاء مستقلين في مجالس الشركات غير المدرجة ومتى يصبح ذلك ضروريا.
                            </p>
                            <p>
                                3- انتقال القيادة بين الأجيال وإدارة التغيير، وجاهزية الشركات للتحول إلى شركات مساهمة أو للطرح.
                            </p>
                            <p>
                                4- استعراض دروس مستفادة من التجارب السعودية في التحول المؤسسي
                            </p>
                            </div>

                            <SpeakerCard
                                image={aaed}
                                alt="الدكتور عائذ المبارك"
                                name="الدكتور عائذ المبارك"
                                title="الرئيس التنفيذي في المركز الوطني للمنشآت العائلية"
                                size="small"
                                className="self-center mt-auto"
                            />
                        </AnimatedItem>

                        <AnimatedItem
                            className="bg-white rounded-[20px] p-8 flex flex-col h-full"
                            style={{
                            boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                            المحور الثالث
                            </h3>
                            <h4 className="text-black md:text-[29px] text-[22px] font-semibold mb-6 text-center leading-relaxed px-4">
                            تحول مفاهيم الحوكمة في القطاع العام وتوجيه السياسات والاجراءات
                            </h4>
                            
                            <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                            <p>
                                1- الحوكمة في القطاع العام: تعزيز الكفاءة والشفافية والمساءلة في صنع القرار والسياسات العامة
                            </p>
                            <p>
                                2- الحوكمة القائمة على البيانات: توظيف البيانات في تحسين اتخاذ القرار ورفع كفاءة الأداء الحكومي
                            </p>
                            <p>
                                3- الحوكمة التشريعية: الإشراف على رصد الاختلالات في المنظومة التشريعية ومعالجتها بما يعزز البيئة الاستثمارية
                            </p>
                            </div>

                            <SpeakerCard
                                image={salman}
                                alt="الأستاذ سلمان التخيفي"
                                name="الأستاذ سلمان التخيفي"
                                title="مدير عام التحليل وذكاء الأعمال في المركز الوطني للتنافسية"
                                size="small"
                                className="self-center mt-auto"
                            />
                        </AnimatedItem>

                        <AnimatedItem
                            className="bg-white rounded-[20px] p-8 flex flex-col h-full"
                            style={{
                            boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                            المحور الرابع
                            </h3>
                            <h4 className="text-black md:text-[29px] text-[22px] font-semibold mb-6 text-center leading-relaxed px-4">
                            الحوكمة كممكن للنمو
                            </h4>
                            
                            <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                            <p>
                                1- توضيح الأدوار والمسؤوليات بما يعزز جودة اتخاذ القرار.
                            </p>
                            <p>
                                2- مواءمة ممارسات الحوكمة مع أهداف النمو.
                            </p>
                            <p>
                                3- ترسيخ الحوكمة كخط دفاع يدعم إدارة المخاطر والالتزام، بما يسهم في رفع كفاءة الأعمال وتحقيق الاستدامة المؤسسية
                            </p>
                            </div>

                            <SpeakerCard
                                image={ali}
                                alt="الاستاذ علي الهزاني"
                                name="الاستاذ علي الهزاني"
                                title="مدير عام الحوكمة المؤسسية في شركة الاتصالات السعودية"
                                size="small"
                                className="self-center mt-auto"
                            />
                        </AnimatedItem>

                    </AnimatedGroup>
                </div>
            </AnimatedSection>

            <AnimatedSection as="div" dir="rtl" className="w-full bg-[#F5F6F8] p-6 md:p-12 flex flex-col items-center">
                <div className="w-full max-w-[1200px]">
                    
                    <h2 className="text-[43px] font-normal text-black mb-12">
                    تفاصيل الجلسة الثانية والختامية
                    </h2>

                    <div className="flex flex-col mb-16 w-full">
                    <h3 className="text-[#3E82B9] text-[29px] font-bold mb-4">
                        ادارة الجلسة:
                    </h3>
                    
                    <SpeakerCard
                        image={ahmedAlKhebty}
                        alt="الدكتور أحمد بن سعيد الخبيتي"
                        name="الدكتور أحمد بن سعيد الخبيتي"
                        title="المستشار القانوني العام وعضو هيئة التدريس في كلية الحقوق والعلوم السياسية جامعة الملك سعود"
                        bgClass="bg-[#F5F6F8]"
                        className="self-start"
                    />
                    </div>

                    <AnimatedGroup className="flex flex-col gap-8 w-full">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 w-full">
                        
                        <AnimatedItem
                        className="bg-white rounded-[20px] p-8 flex flex-col h-full"
                        style={{
                            boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                        }}
                        >
                        <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                            المحور الاول
                        </h3>
                        <h4 className="text-black md:text-[29px] text-[22px] font-semibold mb-6 leading-relaxed px-4">
                            الإطار التنظيمي والحوكمة المؤسسية للقطاع غير الربحي
                        </h4>
                        
                        <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                            <p>1- تشريعات وحوكمة القطاع غير الربحي</p>
                            <p>2- أدوار مجالس الأمناء والجمعيات العمومية</p>
                            <p>3- استقلالية القرار ومنع تضارب المصالح</p>
                            <p>4- أهمية الحوكمة في تعزيز الثقة المجتمعية</p>
                        </div>

                        <SpeakerCard
                            image={fahd}
                            alt="الدكتور فهد الماجد"
                            name="الدكتور فهد الماجد"
                            title="نائب محافظ هيئة الأوقاف"
                            size="small"
                            className="self-center mt-auto"
                        />
                        </AnimatedItem>

                        <AnimatedItem
                        className="bg-white rounded-[20px] p-8 flex flex-col h-full"
                        style={{
                            boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                        }}
                        >
                        <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                            المحور الثاني
                        </h3>
                        <h4 className="text-black md:text-[29px] text-[22px] font-semibold mb-6 leading-relaxed px-4">
                            الشفافية والمساءلة وإدارة المخاطر
                        </h4>
                        
                        <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                            <p>1- الشفافية في الإفصاح المالي وغير المالي</p>
                            <p>2- آليات المساءلة الداخلية والخارجية</p>
                            <p>3- إدارة المخاطر في المنظمات غير الربحية</p>
                            <p>4- حوكمة جمع التبرعات وضمان استخدامها</p>
                        </div>

                        <SpeakerCard
                            image={haitham}
                            alt="الاستاذ هيثم الفايز"
                            name="الاستاذ هيثم الفايز"
                            title="الرئيس التنفيذي لشركة وقف سليمان الراجحي القابضة"
                            size="small"
                            className="self-center mt-auto"
                        />
                        </AnimatedItem>

                    </div>

                    <AnimatedItem
                        className="bg-white rounded-[20px] p-8 flex flex-col w-full"
                        style={{
                        boxShadow: '0px 9.44px 14.15px 0px rgba(0, 0, 0, 0.1), 0px -0.94px 5.66px 0px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <h3 className="text-[#3E82B9] text-[29px] font-bold mb-6 text-center">
                        المحور الثالث
                        </h3>
                        <h4 className="text-black text-[29px] font-semibold mb-6 leading-relaxed px-4">
                        إدارة الموارد المالية وتنمية الاستدامة
                        </h4>

                        <div className="flex-grow flex flex-col gap-4 text-[#111827] text-[22px] font-normal  mb-12">
                            <p>1- مصادر التمويل وتنويعها</p>
                            <p>2- إدارة الميزانيات والمصروفات بكفاءة</p>
                            <p>3- بناء نماذج الاستدامة المالية</p>
                            <p>4- تطوير الشراكات الوقفية والتنموية</p>
                            <p>5- استخدام التكنولوجيا لتحسين الكفاءة</p>
                        </div>

                        <SpeakerCard
                            image={ibrahim}
                            alt="الدكتور ابراهيم الحيدري"
                            name="الدكتور ابراهيم الحيدري"
                            title="الرئيس التنفيذي لصندوق الوقف الصحي في وزارة الصحة - سابقاً -"
                            size="small"
                            className="self-center mt-auto"
                        />
                    </AnimatedItem>

                    </AnimatedGroup>
                </div>
            </AnimatedSection>
        </>
    );
};

export default Sessions;
